var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 67"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#2895EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5785 4.26394C9.88829 3.96541 10.3906 3.96541 10.7003 4.26394L15.46 8.85051C15.7698 9.14904 15.7698 9.63305 15.46 9.93157L10.7003 14.5181C10.3906 14.8167 9.88829 14.8167 9.5785 14.5181C9.26871 14.2196 9.26871 13.7356 9.5785 13.4371L12.9839 10.1555H3.79327C3.35516 10.1555 3 9.81322 3 9.39104C3 8.96886 3.35516 8.62661 3.79327 8.62661H12.9839L9.5785 5.345C9.26871 5.04647 9.26871 4.56246 9.5785 4.26394Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow-forward.85b75b87fc5ddb54c4a6cfb6d8fc6e59.svg";
export { ForwardRef as ReactComponent };